import React, { useState, useEffect } from 'react';
import { checkCourseCompletion, getStatusLabels, getStatusDescriptions } from '../../utils/courseProgress';

const CourseProgressIndicator = ({ course }) => {
  const [status, setStatus] = useState({
    syllabusSegmented: false,
    assignmentsReady: false,
    answerSheetsAvailable: false,
    vocabListsReady: false
  });
  const [loading, setLoading] = useState(true);
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    const loadProgress = async () => {
      try {
        const courseStatus = await checkCourseCompletion(course);
        setStatus(courseStatus);
      } catch (error) {
        console.error('Error loading course progress:', error);
      } finally {
        setLoading(false);
      }
    };

    loadProgress();
  }, [course]);

  const statusLabels = getStatusLabels();
  const statusDescriptions = getStatusDescriptions();

  const statusOrder = ['syllabusSegmented', 'assignmentsReady', 'answerSheetsAvailable', 'vocabListsReady'];

  if (loading) {
    return (
      <div className="flex items-center gap-1.5">
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className="w-2 h-2 bg-gray-200 rounded-full animate-pulse"></div>
        ))}
      </div>
    );
  }

  return (
    <div className="relative">
      <div 
        className="flex items-center gap-1.5"
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
      >
        {statusOrder.map((key, index) => (
          <div
            key={key}
            className={`w-2 h-2 rounded-full transition-colors duration-300 ${
              status[key] 
                ? 'bg-green-500 shadow-sm' 
                : 'bg-gray-300'
            }`}
            title={statusLabels[key]}
          ></div>
        ))}
      </div>

      {/* Tooltip */}
      {showTooltip && (
        <div className="absolute bottom-full right-0 mb-2 w-72 bg-gray-900 text-white text-xs rounded-lg p-3 shadow-lg z-50 pointer-events-none">
          <div className="font-semibold mb-2">Course Readiness Status</div>
          <div className="space-y-1.5">
            {statusOrder.map((key) => (
              <div key={key} className="flex items-center gap-2">
                <div
                  className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${
                    status[key] ? 'bg-green-400' : 'bg-gray-400'
                  }`}
                ></div>
                <div className="flex-1">
                  <div className={`font-medium ${status[key] ? 'text-green-300' : 'text-gray-300'}`}>
                    {statusLabels[key]}
                  </div>
                  <div className="text-gray-400 text-xs leading-tight">
                    {statusDescriptions[key]}
                  </div>
                </div>
              </div>
            ))}
          </div>
          
          {/* Arrow pointer */}
          <div className="absolute top-full right-4 w-0 h-0 border-l-4 border-r-4 border-t-4 border-l-transparent border-r-transparent border-t-gray-900"></div>
        </div>
      )}
    </div>
  );
};

export default CourseProgressIndicator;